const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-3 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke: gray;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: gray;\r\n      }\r\n\r\n      .cls-5 {\r\n        stroke: none;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  width: 11,
  height: 13
})));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Repeat_Grid_19",
  "data-name": "Repeat Grid 19",
  className: "cls-2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_161",
  "data-name": "Group 161"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_1175",
  "data-name": "Rectangle 1175",
  className: "cls-3"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-5",
  width: 11,
  height: 11,
  rx: 4
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 0.5,
  y: 0.5,
  width: 10,
  height: 10,
  rx: 3.5
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_303",
  "data-name": "Path 303",
  className: "cls-4",
  d: "M2.409,4,0,1.594.778.815,2.409,2.409,4.818,0,5.6.778Z",
  transform: "translate(2.595 3.847)"
})));
function SvgCheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.4f96b78b3baf16716a4d2a4037458ab2.svg";
export { ForwardRef as ReactComponent };